// Called by : src/App.vue (button-about)

<template>
    <button id="nav_pge_about" class="btn btn-outline-light px-4 py-2 txt_ombre_333 txt_size_125" data-toggle="modal" data-target="#pge_about">
        <span class="oi oi-double-quote-serif-left mr-2"></span>
        {{ $t('infos.about') }}
    </button>
</template>

<script>
export default {
    // void
}
</script>

<style scoped>
    /* void */
</style>



// WEBPACK FOOTER //
// src/components/header/ButtonAbout.vue